import axios from 'axios'

const http = axios.create({
  baseURL: '/leads'
})
http.interceptors.response.use(res => {
  if (!res.data) {
    return res.data
  }
  if (!res.data.status) {
    return Promise.reject(new Error(res.data.errorMessage))
  }
  return res.data.data
})

export default http
